module.exports = __webpack_public_path__ + "img/t_air.77cf8897.jpg";